module.exports = __webpack_public_path__ + "static/img/10.070c8d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/10.png
// module id = Ywjt
// module chunks = 0